import { LiveUpdate } from "@capawesome/capacitor-live-update";
import { isNativePlatform } from "src/capacitor/appsHelpers";

// Potwierdza, że bundle live update wystartował. Bez tego po readyTimeout plugin wraca do poprzedniego bundla.
export const markLiveUpdateReady = () => {
	if (!isNativePlatform()) return;
	LiveUpdate.ready().catch(console.error);
};
